"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navigation = void 0;
// tslint:disable
const BaseAvroRecord_1 = require("../../../BaseAvroRecord");
class Navigation extends BaseAvroRecord_1.BaseAvroRecord {
    constructor() {
        super(...arguments);
        this.navigationType = null;
    }
    schema() {
        return Navigation.schema;
    }
    subject() {
        return Navigation.subject;
    }
}
exports.Navigation = Navigation;
Navigation.subject = "navigation";
Navigation.schema = {
    "type": "record",
    "name": "Navigation",
    "namespace": "storyblocks.common.frontend",
    "fields": [
        {
            "name": "referrerUrl",
            "type": "string"
        },
        {
            "name": "navigationType",
            "type": [
                "null",
                {
                    "type": "enum",
                    "name": "NavigationType",
                    "namespace": "storyblocks.common.enums",
                    "symbols": [
                        "TYPE_NAVIGATE",
                        "TYPE_RELOAD",
                        "TYPE_BACK_FORWARD",
                        "TYPE_RESERVED",
                        "OUTDATED_SCHEMA"
                    ],
                    "default": "OUTDATED_SCHEMA"
                }
            ],
            "default": null
        }
    ]
};
//# sourceMappingURL=Navigation.js.map